<li class="yllw-sidenav__item">
    <button type="button" class="yllw-sidenav__item-link yllw-sidenav__group-toggle"
        cdkOverlayOrigin #trigger="cdkOverlayOrigin"
        [class.yllw-sidenav__group-toggle--active]="active()"
        [class.yllw-sidenav__group-toggle--flyout-open]="flyoutOpen()"
        (click)="expanded() ? toggle.emit() : openFlyoutRequest.emit()"
        (mouseenter)="!expanded() && openFlyoutRequest.emit()"
        (mouseleave)="scheduleClose.emit()"
        [attr.aria-label]="group().labelKey | translate">
        <i class="pi pi-{{ group().icon }} yllw-sidenav__item-icon"></i>
        @if (expanded()) {
            <span class="yllw-sidenav__item-text">{{ group().labelKey | translate }}</span>
            <i class="pi pi-chevron-down yllw-sidenav__group-chevron"
                [class.yllw-sidenav__group-chevron--open]="open()"></i>
        } @else {
            <i class="pi pi-angle-right yllw-sidenav__group-caret"></i>
        }
    </button>
    <ng-template cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="!expanded() && flyoutOpen()"
        [cdkConnectedOverlayPositions]="flyoutPositions()"
        (overlayKeydown)="$event.key === 'Escape' ? closeFlyout.emit() : null">
        <div class="yllw-sidenav__flyout" cdkTrapFocus
            (mouseenter)="cancelClose.emit()" (mouseleave)="scheduleClose.emit()">
            <div class="yllw-sidenav__flyout-title">{{ group().labelKey | translate }}</div>
            @for (section of group().sections; track section.id ?? $index) {
                <app-sidenav-section [section]="section" [expanded]="true" />
            }
        </div>
    </ng-template>
</li>
@if (expanded()) {
    <li class="yllw-sidenav__group-content" [class.yllw-sidenav__group-content--open]="open()">
        <div class="yllw-sidenav__group-content-inner">
            @for (section of group().sections; track section.id ?? $index) {
                <app-sidenav-section [section]="section" [expanded]="expanded()" />
            }
        </div>
    </li>
}
